import { z } from "zod";

export const authenticationSchema = z.object({
    credentials: z
        .string({ required_error: "This field is required", invalid_type_error: "This field is required" })
        .min(1, "This field is required"),
});

export const defaultValues = {
    credentials: "",
};

export type AuthenticationType = z.infer<typeof authenticationSchema>;
